module.exports = __webpack_public_path__ + "img/EACalculateItem3.2ca058e9.svg";